


















































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { State, Getter, Action, Mutation, namespace } from 'vuex-class'
import { Account, fetchAccountWithoutRedirect } from 'ykd-base/account'
import {
  PermissionQueryParam,
  queryPermissions
} from '@/api/permission/permission'

import { YKDRightDrawer } from 'gum-ui'
import { Permission } from '@/model/permission/permission'
import { message } from 'ant-design-vue'
import { Pagination, Divider, Popconfirm } from 'ant-design-vue'

// import DelModal from './DelPermissionModal.vue'
const PermissionStore = namespace('app-addressbook/permission')

@Component({
  components: { YKDRightDrawer, 'a-popconfirm': Popconfirm }
})
export default class SavePermission extends Vue {
  @PermissionStore.Action('savePermission') savePermission!: Function
  @PermissionStore.State('permission') permission!: Permission
  @PermissionStore.State('selectedPermission') selectedPermission!: Permission
  @PermissionStore.Mutation('setPermission') setPermission!: Function
  @PermissionStore.Mutation('setSelectedPermission')
  setSelectedPermission!: Function

  private permissionTile: string = ''
  private permissionName: string = ''
  private permissionRemark: string = ''

  private nameWarn: boolean = false
  private titleWarn: boolean = false

  private confirmLoading: boolean = false

  private rightTableTitel: string = ''

  @Prop() visible?: boolean
  @Prop() title?: string

  @Watch('permission')
  permissionChange() {
    this.permissionName = this.permission.name || ''

    this.permissionRemark = this.permission.remark || ''

    this.permissionTile = this.permission.title || ''
  }

  titleChange(e: any) {
    this.permissionTile = e.target.value
    if (this.permissionTile) {
      this.titleWarn = false
    }
  }

  nameChange(e: any) {
    this.permissionName = e.target.value
    if (this.permissionName) {
      this.nameWarn = false
    }
  }

  remarkChange(e: any) {
    this.permissionRemark = e.target.value
  }

  addPermission() {
    this.rightTableTitel = '添加权限'
    this.visible = true
  }

  rightDrawClose() {
    this.$emit('close')
  }

  async confirm() {
    if (!this.permissionTile) {
      this.titleWarn = true
    }

    if (!this.permissionName) {
      this.nameWarn = true
    }

    if (this.permissionTile && this.permissionName) {
      this.confirmLoading = true
      const account: Account = await fetchAccountWithoutRedirect()

      const permission: Permission = await this.savePermission({
        id: this.permission.id || '',
        title: this.permissionTile,
        name: this.permissionName,
        remark: this.permissionRemark,
        companyId: account.companyId
      })
      this.confirmLoading = false
      if (!this.permission.id) {
        this.permissionTile = ''
        this.permissionName = ''
        this.permissionRemark = ''
      }

      if (permission.id) {
        this.refresh()
        this.rightDrawClose()
      }
    }
  }

  refresh() {
    this.rightDrawClose()

    this.$emit('refresh')
  }
}
